import {connect} from "react-redux";
import {DispatchProps, InnerProps, StateProps} from "../components/PdfInteractions";
import {RootState, ThunkDispatch} from "../types";
import {routerTools, Routes} from "../utils/router";
import {doDownloadPdf, doDownloadPdfXML, doGetPdfJson, doGetPdfSignatures} from "../actions/thunks/signatures";
import {gotPdfJson, gotPdfSignatures} from "../actions/signatures";
import {userIsAllowed} from "../utils/commons";
import {doGetUserCredits} from "../actions/thunks/users";
import {PdfSimpleInteractions} from "../components/PdfSimpleInteractions";

function mapStateToProps({user, pdf}: RootState): StateProps {
    return {
        apiKeys: user.credentials,
        signatures: pdf.signatures,
        total: pdf.total,
        stats: user.credits?.document_simple_api,
        json: pdf.json,
        isAllowed: userIsAllowed(user.credits, "document_simple_api"),
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
    return {
        onGoToDocumentation: () => window.open(Routes.DOCS, "_blank"),
        onGoToApiKeys: () => routerTools.push(Routes.API_KEYS),
        onGetPdfSignatures: (q) => dispatch(doGetPdfSignatures(q, false)),
        onResetPdfSignatures: () => dispatch(gotPdfSignatures({items: undefined as any, total: 0})),
        onDownloadPdfXML: (sig) => dispatch(doDownloadPdfXML(sig)),
        onGetPdfJson: (sig) => dispatch(doGetPdfJson(sig)),
        onCleanJson: () => dispatch(gotPdfJson(undefined)),
        onDownloadPdf: (sig) => dispatch(doDownloadPdf(sig)),
        onGetUserCredits: () => dispatch(doGetUserCredits()),
    };
}

export default connect<StateProps, DispatchProps, InnerProps, RootState>(mapStateToProps, mapDispatchToProps)(PdfSimpleInteractions);
